import { ChatResponseOption } from '@akin-home/chat';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import Checkbox from 'expo-checkbox';
import styled from 'styled-components/native';
import { getOptionIcon } from '../../functions';

type Props = {
  column?: boolean;
  onPress(value: string): void;
  dont_show_icons?: boolean;
  option: ChatResponseOption;
};

export const ChatOption = (props: Props) => {
  const { onPress, option, column = true } = props;

  const handleSelect = () => onPress(option.input.value);

  const icon = getOptionIcon(option);

  const show_icons = !!option.icon && !props.dont_show_icons;

  const selected = !!option.selected;

  return (
    <Option onPress={handleSelect} column={column && show_icons}>
      {show_icons ? (
        <Emoji>{icon}</Emoji>
      ) : (
        <Checkbox
          value={selected}
          color={selected ? colors.primary[70] : 'white'}
          onChange={handleSelect}
        />
      )}

      {option.label?.length ? (
        <Text weight="semibold" color="white">
          {option.label}
        </Text>
      ) : null}
    </Option>
  );
};

const Option = styled.TouchableOpacity<{ column?: boolean }>`
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  align-items: center;
  gap: 10px;
`;

const Emoji = styled.Text`
  font-size: 50px;
  padding: 10px;
`;
